export default __webpack_public_path__ + "static/media/control-hub.ffcab65c.svg";